import { Check } from 'lucide-react';
import { STEP_ICONS } from './stepIcons';

const HIGHLIGHTS = [
  ['Tempo stimato', '2 minuti'],
  ['Risultato', 'Demo più pertinente'],
  ['Obiettivo', 'Capire priorità e processo attuale'],
];

/** La colonna a lato del modulo: presentazione, avanzamento, step e riepilogo. */
export default function DemoRequestAside({ steps, step, snapshot }) {
  const position = `${step + 1} / ${steps.length}`;
  const positionText = `Passo ${step + 1} di ${steps.length}`;

  return (
    <div className="rounded-hero border border-default bg-default p-7 shadow-resting">
      <p className="text-eyebrow text-link">Richiesta qualificata</p>
      <h1 className="mt-4 text-page-title text-strong">
        Raccontaci come lavori oggi e dove serve più controllo.
      </h1>
      <p className="mt-5 text-body-lg text-muted">
        In pochi passaggi raccogliamo contesto, dimensione flotta, criticità e priorità. Il
        risultato è un brief chiaro per preparare la demo giusta.
      </p>

      <dl className="mt-7 grid gap-3 sm:grid-cols-3">
        {HIGHLIGHTS.map(([label, value]) => (
          <div key={label} className="rounded-2xl border border-default bg-subtle p-4">
            <dt className="text-kpi-label text-muted">{label}</dt>
            <dd className="mt-2 text-card-title text-strong">{value}</dd>
          </div>
        ))}
      </dl>

      <div className="mt-7 rounded-2xl border border-default bg-subtle p-4">
        <div className="flex items-center justify-between text-caption text-subtle">
          <span id="demo-progress-label">Progressione</span>
          <span className="tabular-nums">{position}</span>
        </div>
        <div
          role="progressbar"
          aria-labelledby="demo-progress-label"
          aria-valuemin={1}
          aria-valuemax={steps.length}
          aria-valuenow={step + 1}
          aria-valuetext={positionText}
          className="mt-3 h-2 rounded-full bg-strong"
        >
          <div
            className="h-full rounded-full bg-brand"
            style={{ width: `${((step + 1) / steps.length) * 100}%` }}
          />
        </div>
      </div>

      <ol className="mt-7 space-y-3">
        {steps.map((item, index) => {
          const Icon = index < step ? Check : STEP_ICONS[index];
          const active = index === step;
          return (
            <li
              key={item.label}
              aria-current={active ? 'step' : undefined}
              className={`flex items-center gap-3 rounded-xl border bg-default p-4 ${
                active ? 'border-brand' : 'border-default'
              }`}
            >
              <span
                className={`flex size-10 shrink-0 items-center justify-center rounded-xl ${
                  index <= step ? 'bg-selected text-on-emphasis' : 'bg-muted text-placeholder'
                }`}
              >
                <Icon aria-hidden className="size-4" />
              </span>
              <div>
                <p className="text-kpi-label text-subtle">
                  Passo {index + 1}
                  {index < step && <span className="sr-only"> (completato)</span>}
                </p>
                <p className="mt-1 text-card-title text-strong">{item.title}</p>
                <p className="mt-1 text-caption text-subtle">{item.description}</p>
              </div>
            </li>
          );
        })}
      </ol>

      <section
        aria-labelledby="demo-snapshot"
        className="mt-7 rounded-2xl border border-default bg-subtle p-4"
      >
        <h2 id="demo-snapshot" className="text-kpi-label text-subtle">
          Riepilogo
        </h2>
        <dl className="mt-4 space-y-3">
          {snapshot.map(([label, value]) => (
            <div
              key={label}
              className="flex items-start justify-between gap-4 border-b border-subtle pb-3 last:border-b-0 last:pb-0"
            >
              <dt className="text-kpi-label text-subtle">{label}</dt>
              <dd className="text-right text-sm text-strong">{value}</dd>
            </div>
          ))}
        </dl>
      </section>
    </div>
  );
}
